module.exports = "<div class=\"pic-wrap mod-news-text-video x-video\" style=\"display:none\">\n\t<div class=\"img-container\" style=\"<%= height ? 'padding-bottom:' + height : '' %>\">\n\t\t<video preload=\"meta\" webkit-playsinline poster=\"<%- poster %>\" data-ratio=\"<%= height %>\" data-vid=\"<%= vid %>\" data-src=\"<%- src %>\"></video>\n\t\t<div class=\"layer\">\n\t\t\t<span class=\"tag\"><%- tag %></span>\n\t\t\t<!-- <span class=\"time\">05:87</span> -->\n\t\t</div>\n\t</div>\n\t<% if (title) { %>\n\t<h3><%- title %></h3>\n\t<% } %>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/HTMLTag/video.ejs
// module id = 8
// module chunks = 0